import { Select } from "antd";
import { useTranslation } from "react-i18next";

import { useIsFormEnginePreviewMode } from "@/components/FormEngine/hooks/useIsFormEnginePreviewMode";
import { getIntValue } from "@/utilities/number";
import { capitalize } from "@/utilities/string";

import { SeverityGridPreview } from "./gridUtils";
import { useRiskMatrixFromIntervention } from "./hooks/useRiskMatrixFromIntervention";

// TODO DEV-8551 `Option` is deprecated. Please use `options` instead.
// eslint-disable-next-line @typescript-eslint/no-deprecated
const { Option } = Select;

const ConsequenceComponent = ({ value, ...selectProps }) => {
  const { t } = useTranslation();
  const { riskMatrix } = useRiskMatrixFromIntervention();
  const isPreviewMode = useIsFormEnginePreviewMode();

  const consequences = isPreviewMode
    ? SeverityGridPreview.buildSampleConsequences()
    : (riskMatrix?.consequences ?? []);

  return (
    <Select
      {...selectProps}
      value={getIntValue(value)}
      placeholder={t("form:staticField.consequence.placeholder")}
    >
      {consequences.map(({ name, value }) => (
        <Option key={value} value={getIntValue(value)}>
          {capitalize(name)}
        </Option>
      ))}
    </Select>
  );
};

export default ConsequenceComponent;
